module.exports = __webpack_public_path__ + "img/arm-right-back.9c2145fd.png";